module.exports = __webpack_public_path__ + "img/profile_off.0781ddff.svg";